import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ExitButton,
	PurchaseOrderPage
} from '../../../features/distributor/purchase-order';
import '../../../css/order.scss';
import {
	CreditMemoBillToPanel,
	CreditMemoFiles,
	CreditMemoFilesButton,
	CreditMemoInformationPanel,
	CreditMemoPage,
	CreditMemoDetailsPanel,
	CreditMemoShipToPanel
} from '../../../features/distributor/credit-memo';
import { useTitle } from '../../../contexts/title';
import { useEffect } from 'react';

export default function CreditMemoDetailsPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Credit Memo Details')
	}, [pageTitle]);


	return (

		<PurchaseOrderPage>

			<CreditMemoPage>

				<Toolbar className='button-toolbar'>
					<ToolbarItem location={'after'}>
						<CreditMemoFilesButton />
					</ToolbarItem>
					<ToolbarItem location={'after'}>
						<ExitButton />
					</ToolbarItem>
				</Toolbar>
				<Box>
					<Item ratio={1}>
						<CreditMemoInformationPanel />
					</Item>
					<Item ratio={1}>
						<CreditMemoBillToPanel />
					</Item>
					<Item ratio={1}>
						<CreditMemoShipToPanel />
					</Item>
				</Box>

				<CreditMemoFiles />

				<CreditMemoDetailsPanel />

			</CreditMemoPage>

		</PurchaseOrderPage>
	)
}
